export default __webpack_public_path__ + "static/media/4.5db8a74e.png";